<template>
  <div class="tabs-wrapper">

    <div class="tabs">
      <ul>
        <li v-for="(tab, index) in tabs" :key="index" :class="{ 'is-active': tab.isActive }">
          <a :href="tab.href" @click="selectTab(tab)">{{ tab.name }}</a>
        </li>
      </ul>
    </div>

    <div class="tabs-details">
      <slot></slot>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'tabs',

    data() {
      return {
        tabs: []
      }
    },

    created() {
      this.tabs = this.$children;
    },

    methods: {
      selectTab(selectedTab) {
        this.tabs.forEach(tab => {
          tab.isActive = (tab.name == selectedTab.name);
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
.tabs {
  background-color: var(--white);
}

.tabs ul {
  display: flex;
  justify-content: space-around;
  margin: 0;
  padding: 0;
}

.tabs li {
  list-style: none;
  cursor: pointer;
  border: 1px solid #c4c4c4;
  padding: 5px;
  flex-grow: 1;
}

.tabs a {
  display: block;
  text-align: center;
  font-family: var(--noto);
  font-size: 1.125rem;
  line-height: 1.5;
  font-weight: 400;
  color: #4c4c4d;
  text-decoration: none;
}

.is-active {
  background-color: #eedaa3;
}

.is-active a {
  color: var(--black);
}

.tabs-details {
  background-color: rgba(255, 255, 255, 0.75);
  padding: 10px 50px 40px;
}
</style>
